import React, { Component } from 'react';
import AppBar from '@material-ui/core/AppBar';
import Card from '@material-ui/core/Card';
//import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { TextField } from '@material-ui/core';
import './App.css';

class HeaderContainer extends Component {
  render() {
    return (
      <div className="header">
        <AppBar id="header" position="absolute">
          <Toolbar style={{ justifyContent: "center" }}>
            <Typography style={{ marginRight: "15px" }} variant="h6">DGLO</Typography>
            <SearchForm
              formeFilter={this.props.formeFilter}
              onFilterChange={this.props.onFilterChange} />
          </Toolbar>
        </AppBar>
        <Toolbar />
      </div >
    );
  }
}

class SearchForm extends Component {
  render() {
    return (
      <form noValidate autoComplete="off" onSubmit={(e) => { e.target[0].blur(); e.preventDefault(); this.props.onFilterChange(e.target[0].value, 0) }}>
        <TextField placeholder="Cercar un mot" value={this.props.formeFilter} id="outlined-basic" variant="outlined" onChange={(e) => { this.props.onFilterChange(e.target.value, 0) }} />
      </form>
    );
  }
}

class SearchContainer extends Component {
  render() {
    return (
      <div className="search" style={{ backgroundImage: `url(${process.env.PUBLIC_URL + '/logo512bg.png'})` }} >
        <SearchResults
          entrees={this.props.entrees}
          pagination={this.props.pagination}
          firstLastTotal={this.props.firstLastTotal}
          resultsPerPage={this.props.resultsPerPage}
          onPaginationClick={this.props.onPaginationClick}
          onCardClick={this.props.onCardClick} />
      </div>);
  }
}

class SearchResults extends Component {
  render() {
    if (!this.props.entrees || this.props.entrees === []) {
      return (
        <div id="searchResults" className="searchResults">
          {/* <Typography color="textSecondary" gutterBottom>Cercar un mot</Typography> */}
        </div>
      );
    }

    // console.log("Entrees")
    // console.log(this.props.entrees)
    return (
      <div id="searchResults" className="searchResults">
        <div className="results">
          {this.props.entrees != null && this.props.entrees.map((entree, idx) =>
            <Card id={"card" + idx} key={entree.forme + idx} style={{ marginBottom: "5px", marginTop: "5px" }}>
              <CardContent>
                <Typography component="h5">
                  <b style={{ color: "blue" }}>{entree.forme}</b>
                </Typography>
                <Typography color="textSecondary">
                  {entree.catgram}
                </Typography>
                {/* entree.api && entree.api.length > 0 &&
                      <Typography component="i">
                        API: {entree.api}
                      </Typography>
                    /*}
  
                    {
                      /* entree.variantes && entree.variantes.length > 0 &&
                      <Typography variant="body2" component="p">
                        <span>variantes:</span>
                        <ul>
                          {entree.variantes.map((v, idx) =>
                            <>
                              <li>{v.forme} (
                                {v.regions && v.regions.length > 0 && v.regions.map(r => <span>{r}</span>)
                                  .reduce((prev, curr) => [prev, ', ', curr])}
                              )</li>
                            </>
                          )}
                        </ul>
                      </Typography>
                      */}

                {entree.origine && entree.origine.length > 0 &&
                  <Typography variant="body2">
                    <i>{entree.origine}</i>
                  </Typography>
                }



                {entree.origine && entree.origine.length > 0
                  && entree.dateintro && entree.dateintro.length > 0 &&
                  <span> - </span>}
                {entree.dateintro && entree.dateintro.length > 0 &&
                  <Typography component="i">
                    <i>{entree.dateintro}</i>
                  </Typography>
                }

                {entree.erronnees && entree.erronnees.length > 0 &&
                  <Typography variant="body2" component="span">
                    {/* <span>formes érronées:</span> */}
                    <ul>
                      {entree.erronnees.map((erron, idx) =>
                        <li key={erron + idx}>
                          <s>{erron}</s>
                        </li>
                      )}
                    </ul>
                  </Typography>
                }

                {entree.sens && entree.sens.length > 0 &&
                  <Typography variant="body1" component="span">
                    {entree.sens.map((sens, idx) =>
                      <>
                        <br />
                        {(entree.sens.length > 1) && <span>{idx + 1}. </span>}
                        {sens.nivlangue && sens.nivlangue.length > 0 && <span style={{ color: "red" }}><i>{sens.nivlangue}</i>, </span>}
                        {sens.domaine && sens.domaine.length > 0 && <span style={{ color: "red" }}><i>{sens.domaine}</i> </span>}
                        {/*sens.definitions && sens.definitions.length > 0 &&
                              <Typography variant="body2" component="p">
                                <span>définitions:</span>
                                <ul>
                                  {sens.definitions.map((d, idx) =>
                                    <>
                                      <li>{d}</li>
                                    </>
                                  )}
                                </ul>
                              </Typography>
                                  */}
                        <b>{sens.traductions && sens.traductions.join(", ")}</b>

                        {sens.formeref && sens.formeref.length > 0 && <br />}
                        {sens.formeref && sens.formeref.length > 0 && <span><span style={{ color: "red", fontSize: "200%" }}>&rarr; </span><span style={{ color: "blue" }}>{sens.formeref}</span></span>}

                        {sens.renvois && sens.renvois.length > 0 && <br />}
                        {sens.renvois && sens.renvois.length > 0 &&
                          <Typography variant="body2" component="span">
                            <ul style={{ listStyleType: "none" }}>
                              {sens.renvois.map((r, idx) =>
                                <li key={r + idx}>
                                  <span style={{ color: "red", fontSize: "200%" }}>&rarr; </span>{r}
                                </li>
                              )}
                            </ul>
                          </Typography>
                        }
                      </>
                    )}
                  </Typography>
                }
                {entree.sens && entree.sens.length > 0
                  && entree.sens[0].contextes && entree.sens[0].contextes.length > 0 && <div><br /><br /></div>}
                {entree.sens && entree.sens.length > 0 && entree.sens.map((sens, idx) =>
                  sens.contextes && sens.contextes.length > 0 &&
                  <Typography variant="body2" component="span">
                    <span>Contextes:</span>
                    <ul>
                      {sens.contextes.map((c, idx) =>
                        <li key={c.text + idx}>
                          {c.type} : <i>{c.text} (fr.: {c.traduction})</i>
                        </li>
                      )}
                    </ul>
                  </Typography>
                )}
                {entree.attestations && entree.attestations.length > 0 && <br />}
                {entree.attestations && entree.attestations.length > 0 &&
                  <Typography variant="body2" component="span">
                    <span>attestations:</span>
                    <ul>
                      {entree.attestations.map((a, idx) =>
                        <li key={a.source + idx}>
                          {a.source}
                          {a.forme && <span> ({a.forme})</span>}
                        </li>
                      )}
                    </ul>
                  </Typography>
                }
              </CardContent>
            </Card>
          )}
        </div>
        { this.props.firstLastTotal[2] > this.props.resultsPerPage &&
          <div className="pagination">
            <Button style={{ float: "left", margin: "5px" }} onClick={() => this.props.onPaginationClick(-1, this.props.firstLastTotal[2])} variant="contained">Préc.</Button>
            {this.props.firstLastTotal[0]}-{this.props.firstLastTotal[1]} / {this.props.firstLastTotal[2]}
            <Button style={{ float: "right", margin: "5px" }} onClick={() => this.props.onPaginationClick(1, this.props.firstLastTotal[2])} variant="contained">Suiv.</Button>
          </div>
        }
      </div>
    );
  }
}

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchEntrees: [],
      firstLastTotal: [0, 0, 0],
      formeFilter: "",
      pagination: 0,
      isLoading: true
    };
    this.handleFilterChange = this.handleFilterChange.bind(this);
    this.handlePaginationClick = this.handlePaginationClick.bind(this);
    // changing this variable requires changing the cgi handler as well
    this.resultsPerPage = 10;
  }

  handlePaginationClick(increment, limit) {
    var pagination = this.state.pagination + increment;
    if (pagination === -1) {
      return
    }
    if (pagination * this.resultsPerPage > limit) {
      return
    }
    document.getElementById('searchResults').scrollIntoView();
    this.handleFilterChange(null, pagination)
  }

  handleFilterChange(formeFilter, pagination) {
    //console.log("filterChange: " + formeFilter + " - pagination: " + pagination)
    // Do not load anything if already loading

    if (formeFilter === "" || formeFilter === undefined) {
      this.setState({
        formeFilter: "",
        searchedEntrees: [],
        firstLastTotal: [0, 0, 0]
      })
      return
    }

    var reqState;
    if (formeFilter !== null && formeFilter.length > 0) {
      reqState = {
        formeFilter: formeFilter,
        pagination: pagination
      }
    } else {
      reqState = {
        pagination: pagination
      }
    }

    this.setState(reqState, () => {
      var queryParams = "?q=" + this.state.formeFilter
      var queryPagination = "&offset=" + (pagination * this.resultsPerPage) + "&limit=" + this.resultsPerPage
      // DEVELOPMENT
      //var url = "/entree/" + queryParams + queryPagination
      // With Golang server
      var url = process.env.PUBLIC_URL + "/dglo/cgi-bin/dglo.cgi" + queryParams + queryPagination
      // WORKAROUND with busybox
      //var url = "/cgi-bin/dglo.cgi" + queryParams + queryPagination

      //console.log(url)
      fetch(url)
        .then(response => {
          if (response.ok) {
            //console.log(response.json())
            return response.json();
          } else {
            throw new Error('Something went wrong ...');
          }
        })
        .then(data => this.setState(
          {
            searchedEntrees: data.entrees,
            firstLastTotal: [data.first, data.last, data.total],
          }))
        .catch(error => this.setState({
          error: false
        }));

    });
    document.getElementById('header').scrollIntoView();
  }


  render() {
    return (
      <div className="wrapper">
        <HeaderContainer
          formeFilter={this.state.formeFilter}
          onFilterChange={this.handleFilterChange}
        />
        <SearchContainer
          entrees={this.state.searchedEntrees}
          pagination={this.state.pagination}
          firstLastTotal={this.state.firstLastTotal}
          resultsPerPage={this.resultsPerPage}
          onPaginationClick={this.handlePaginationClick} />
        <div className="footer">
          <p><i>Academia occitana</i></p>
        </div>
      </div>
    );
  }
}

export default App;
